var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M125,22.2c-1.5,1-27.9,17.2-58.7,36.1C35.5,77.1,10.2,92.7,10,92.9c-0.1,0.2,0.6,1.7,1.6,3.4l1.8,3.1l6.1-3.7c3.4-2,29.1-17.8,57.3-35.1L128,29.1l51.4,31.6c28.3,17.4,54.1,33.2,57.3,35.1l5.8,3.6l1.8-3.1c1-1.7,1.7-3.2,1.6-3.4c-0.4-0.3-118-72.5-118.1-72.4C127.8,20.4,126.5,21.2,125,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M83.7,86.9c-24.2,15.2-44.3,27.9-44.7,28.2c-0.6,0.5-0.7,8-0.6,60.5l0.1,59.9H128h89.5l0.1-59.9c0.1-56.6,0-60-0.7-60.6c-1.1-0.9-87.6-55.2-88.5-55.6C128,59.3,110.4,70.1,83.7,86.9z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.2fc0717d282495c1279e0620e5d02b73.svg";
export { ForwardRef as ReactComponent };